import { useEffect, useState } from "react";
import {
  onAddAppraisal,
  onGetAllOrgAppraisals,
  ongetEmployeeAppr,
  onGetOrgAppraisals,
} from "../services/appraisal";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { useStateSetter } from "./statehooks/UseStateSettersHook";
import { toast } from "react-toastify";

export default () => {
  const { config, SelectedOrg } = useStateGetter();
  const { setLoading } = useStateSetter();
  const [allempappraisal, setallempappraisal] = useState<any[]>([]);
  const { selectedEmployee } = useStateGetter();

  const getemployeeAppr = async () => {
    setLoading(true);

    try {
      var emparr = [];
      var res = await onGetAllOrgAppraisals(SelectedOrg.id, config);

      res.data.map((item: any) => {
        if (
          item.target == "employee" &&
          item.employeeID == selectedEmployee.id
        ) {
          emparr.push(item);
        }
        if (
          item.target == "organization" &&
          item.organizationID == selectedEmployee.organizationID
        ) {
          emparr.push(item);
        }
        if (item.target == "dept" && item.deptID == selectedEmployee.deptID) {
          emparr.push(item);
        }
        if (
          item.target == "position" &&
          item.positionID == selectedEmployee.positionID
        ) {
          emparr.push(item);
        }
      });
      setallempappraisal(emparr);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getemployeeAppr();
  }, []);
  return {
    allempappraisal,
    getemployeeAppr,
  };
};
